module.exports = __webpack_public_path__ + "e821b2045578bc233ec3a654d766b310.svg";